import React, { useState } from "react";
import TabPanel from "../../../components/TabPanel";

// material ui
import Typography from "@material-ui/core/Typography";
// import useStyles from "./styles";
import useStyles from "./style";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  IconButton,
} from "@material-ui/core";
import rewardSaya from "../../../assets/images/reward.svg";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Skeleton } from "@material-ui/lab";
import DialogAlamatTersimpan from "./DialogAlamatTersimpan";

export default function ProdukReward({ value, loading, products, MyPoints }) {
  const classes = useStyles();
  const [dialogProduk, setDialogProduk] = useState(false);
  const [drawerProduk, setDrawerProduk] = useState({
    open: false,
    data: {},
  });
  const [dialogAlamat, setDialogAlamat] = useState({
    open: false,
    data: {},
  });
  const products_reward = products?.sort(
    (a, b) => a?.variants?.[0]?.harga_poin - b?.variants?.[0]?.harga_poin
  );

  function ProdukDialog() {
    return (
      <Dialog
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
        open={dialogProduk}
        onClose={() => {
          setDialogProduk(false);
        }}
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => {
                setDialogProduk(false);
              }}
              style={{ marginRight: 15 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Produk Reward</Typography>
          </div>
        </DialogTitle>
        {/* <Header
          title="Produk Reward"
          type="with-title"
          onClick={() => {
            setDialogProduk(false);
          }}
        /> */}
        <DialogContent
          dividers
          style={{ display: "table", background: "#efefef", padding: 10 }}
        >
          {/* <div style={{ marginTop: "75px" }}> */}
          {products_reward?.length !== 0 ? (
            <>
              {products_reward?.map?.((item) => {
                const stok = item.variants?.[0]?.stok_available;
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: "10px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                    onClick={
                      stok !== 0
                        ? () => {
                            setDrawerProduk({
                              open: true,
                              data: item,
                            });
                          }
                        : null
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "82.5%",
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {stok < 1 ? (
                          <div
                            style={{
                              backgroundColor: "rgba(31, 31, 31, 0.75)",
                              display: "flex",
                              width: "50px",
                              marginRight: "10px",
                              height: "50px",
                              borderRadius: "50px",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "absolute",
                              transform: "rotate(-20deg)",
                            }}
                          >
                            <Typography
                              noWrap
                              style={{
                                fontSize: "10px",
                                // position: "absolute",
                                color: "white",
                              }}
                            >
                              Habis
                            </Typography>
                          </div>
                        ) : null}
                        <img
                          style={{
                            width: 75,
                            height: 75,
                            marginRight: "10px",
                          }}
                          src={item?.thumbnail?.[0]}
                          alt="logo"
                        />
                      </div>
                      {/*                   
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                        }}
                        src={item?.thumbnail?.[0]}
                        alt="logo"
                      /> */}
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.variants?.[0]?.harga_poin} point
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 15 }}>
                            {item?.nama}
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "darkgray" }}
                          >
                            {item?.deskripsi_singkat}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          marginRight: "5%",
                        }}
                      >
                        {/* {stok === 0 ? (
                          <div
                            style={{
                              backgroundColor: "rgba(31, 31, 31, 0.75)",
                              display: "flex",
                              width: "50px",
                              height: "50px",
                              borderRadius: "50px",
                              justifyContent: "center",
                              alignItems: "center",
                              transform: "rotate(-20deg)",
                            }}
                          >
                            <ShoppingCartIcon
                              style={{
                                transform: "rotate(20deg)",
                              }}
                              // color="primary"
                            />
                            <Typography
                              noWrap
                              style={{
                                fontSize: "8px",
                                position: "absolute",
                                color: "white",
                              }}
                            >
                              Stok Habis
                            </Typography>
                          </div>
                        ) : (
                          <ShoppingCartIcon color="primary" />
                        )} */}
                        <ShoppingCartIcon
                          color={stok < 1 ? "disabled" : "primary"}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <Typography
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
            >
              Tidak Ada Data
            </Typography>
          )}
          {/* </div> */}
        </DialogContent>
      </Dialog>
    );
  }

  function DrawerDetail() {
    return (
      <Drawer
        anchor="bottom"
        open={drawerProduk?.open}
        onClose={() => {
          setDrawerProduk({
            open: false,
            data: {},
          });
        }}
        classes={{
          paper: classes.root2,
          root: classes.root2,
        }}
      >
        <div style={{ margin: "15px" }}>
          {drawerProduk?.data?.variants?.[0]?.harga_poin <= MyPoints ? (
            <>
              <div style={{ display: "grid", justifyContent: "center" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={drawerProduk?.data?.thumbnail?.[0]}
                    alt="icon"
                    style={{
                      width: 150,
                      height: 150,
                    }}
                  />
                </div>
                <Typography
                  align="center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    fontSize: 15,
                    marginBottom: "2.5%",
                    fontWeight: "bold",
                  }}
                >
                  {drawerProduk?.data?.nama}
                </Typography>
              </div>
              <Divider />
              <Typography
                style={{
                  display: "flex",
                  fontSize: 14,
                  marginTop: "15px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Deskripsi Produk Reward
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  fontSize: 14,
                  marginBottom: "15px",
                }}
              >
                {drawerProduk?.data?.deskripsi_lengkap}
              </Typography>
              <Divider />
              <Typography
                style={{
                  display: "flex",
                  marginTop: "15px",
                  fontSize: 14,
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Detail Reward
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "70%",
                  }}
                >
                  <Typography
                    style={{
                      display: "flex",
                      fontSize: 14,
                    }}
                  >
                    Point kamu
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "30%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div>
                    <Typography
                      style={{
                        display: "flex",
                        fontSize: 14,
                      }}
                    >
                      {MyPoints}
                    </Typography>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "70%",
                  }}
                >
                  <Typography
                    style={{
                      display: "flex",
                      fontSize: 14,
                    }}
                  >
                    Point produk
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "30%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div>
                    <Typography
                      style={{
                        display: "flex",
                        fontSize: 14,
                      }}
                    >
                      {drawerProduk?.data?.variants?.[0]?.harga_poin}
                    </Typography>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    marginBottom: "15px",
                    width: "70%",
                  }}
                >
                  <Typography
                    style={{
                      display: "flex",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    Total point kamu
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "30%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div>
                    <Typography
                      style={{
                        display: "flex",
                        fontSize: 14,
                      }}
                    >
                      {MyPoints - drawerProduk?.data?.variants?.[0]?.harga_poin}
                    </Typography>
                  </div>
                </div>
              </div>
              <Divider />
              <div
                style={{
                  marginTop: "20px",
                  marginBottom: "30px",
                  marginLeft: 24,
                  border: "1px solid #5675D3",
                  marginRight: 24,
                  borderRadius: 4,
                  backgroundColor: "#DEE4F7",
                  padding: "12px",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div style={{ marginRight: 8, alignSelf: "center" }}>
                  <InfoOutlinedIcon color="primary" />
                </div>
                <div style={{ marginTop: "2.5px" }}>
                  <Typography
                    color="primary"
                    style={{
                      fontSize: 13,
                      color: "#5675D3",
                    }}
                  >
                    untuk melihat reward yang sudah kamu tukar, silahkan periksa
                    di Riwayat saya.
                  </Typography>
                </div>
              </div>
              <Button
                size="small"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  setDialogAlamat({ open: true, data: drawerProduk?.data });
                }}
              >
                Tukar Reward
              </Button>
              <Button
                style={{ marginTop: "10px" }}
                size="small"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => {
                  setDrawerProduk({
                    open: false,
                    data: {},
                  });
                }}
              >
                Tutup
              </Button>
            </>
          ) : (
            <>
              <div style={{ display: "grid", justifyContent: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={rewardSaya}
                    alt="icon"
                    style={{
                      width: 90,
                      height: 90,
                    }}
                  />
                </div>
                <Typography
                  align="center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    fontSize: 20,
                    marginBottom: "2.5%",
                    fontWeight: "bold",
                  }}
                >
                  Maaf Point Kamu Kurang!!
                </Typography>
              </div>
              <Typography
                align="center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  fontSize: 15,
                  marginBottom: "15px",
                }}
              >
                Yuk tambah point kamu dengan cara melakukan transaksi di apk
                Tokorame dengan nominal 1Jt.
              </Typography>
              <Button
                style={{ marginTop: "10px" }}
                size="small"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  setDrawerProduk({
                    open: false,
                    data: {},
                  });
                }}
              >
                Tutup
              </Button>
            </>
          )}
        </div>
      </Drawer>
    );
  }

  return (
    <TabPanel value={value} index="produk">
      {products_reward?.length !== 0 && !loading ? (
        <div style={{ marginLeft: -10, marginRight: -10, marginTop: -10 }}>
          {products_reward?.map?.((item, index) => {
            const stok = item?.variants?.[0]?.stok_available;
            if (index < 5) {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    borderRadius: 8,
                    marginBottom: "10px",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                  onClick={
                    stok !== 0
                      ? () => {
                          setDrawerProduk({
                            open: true,
                            data: item,
                          });
                        }
                      : null
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "1.5%",
                      width: "82.5%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {stok < 1 ? (
                        <div
                          style={{
                            backgroundColor: "rgba(31, 31, 31, 0.75)",
                            display: "flex",
                            width: "50px",
                            marginRight: "10px",
                            height: "50px",
                            borderRadius: "50px",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <Typography
                            noWrap
                            style={{
                              fontSize: "10px",
                              // position: "absolute",
                              color: "white",
                            }}
                          >
                            Habis
                          </Typography>
                        </div>
                      ) : null}
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                        }}
                        src={item?.thumbnail?.[0]}
                        alt="logo"
                      />
                    </div>
                    <div style={{ marginLeft: "1.5%" }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap={true}
                            style={{
                              fontSize: 15,
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.variants?.[0]?.harga_poin} point
                          </Typography>
                        </div>
                      </div>
                      <div>
                        <Typography style={{ fontSize: 15 }}>
                          {item?.nama}
                        </Typography>
                      </div>
                      <div style={{ display: "inline-grid" }}>
                        <Typography
                          noWrap
                          style={{ fontSize: 13, color: "darkgray" }}
                        >
                          {item?.deskripsi_singkat}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "10%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "5%",
                      }}
                    >
                      <ShoppingCartIcon
                        color={stok < 1 ? "disabled" : "primary"}
                      />
                    </div>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      ) : (
        <>
          {loading ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Typography
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
            >
              Tidak Ada Data
            </Typography>
          )}
        </>
      )}
      {products_reward?.length < 5 ? null : (
        <Typography
          color="primary"
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            setDialogProduk(true);
          }}
        >
          Lihat Lainnya
        </Typography>
      )}
      <ProdukDialog />
      <DrawerDetail />
      <DialogAlamatTersimpan
        open={dialogAlamat.open}
        handleClose={() => setDialogAlamat({ open: false, data: {} })}
        handleCloseDrawer={() => setDrawerProduk({ open: false, data: {} })}
        data={dialogAlamat.data}
      />
    </TabPanel>
  );
}
